export type SubmissionEncampStatusValue =
  | "BLOCKED"
  | "NEEDS_CORRECTION"
  | "PROCESSING"
  | "REJECTED"
  | "RESOLVING";

/**
 * Maps each SubmissionStatus to the SubmissionEncampStatus values
 * that staff can assign when a submission is in that status.
 * Statuses not listed here do not support encamp sub-statuses.
 *
 * Keys are string so both Prisma and GraphQL enum types can index
 * without casting. Values use a string literal union for type safety.
 */
export const VALID_ENCAMP_STATUSES: Record<string, SubmissionEncampStatusValue[] | undefined> = {
  NOT_STARTED: ["BLOCKED"],
  IN_PROGRESS: ["BLOCKED", "REJECTED", "RESOLVING"],
  ENCAMP_INITIAL_REVIEW: ["NEEDS_CORRECTION"],
  PROCESSING_SUBMISSION: ["PROCESSING"],
};
